<template>
  <div class="experienceContainer">
    <h1><v-icon>work</v-icon> {{ $t('menu.experience')}}</h1>
    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item v-for="(card, index) in jobCards" :key="index" :color="card.color" fill-dot class="lighten-1">
        <v-card>
          <v-card-title class="lighten-1" :class="[card.color, { 'flex-row-reverse': index%2==1}]">
            <a :href="card.titleLink" target="_blank">
              <img width="100" :src="card.titleImg" :class="{ 'mr-4': index%2==0, 'ml-4': index%2==1 }">
            </a>
          </v-card-title>
          <v-container>
            <v-row>
              <v-col cols="12" md="10">
                <p v-for="(text, indTex) in card.texts" :key="indTex">{{ $t('experience.' + text) }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  name: 'Experience',
  data: () => ({
    jobCards: [{
      color: 'blue',
      titleImg: 'https://www.indragroup.com/cms-content/2025/06/indra-group-logo-dark.svg',
      titleLink: 'https://www.indracompany.com/',
      texts: [
        'indraText1',
        'indraText2',
        'indraText3',
        'indraText4',
        'indraText5',
      ],
    },{
      color: 'purple',
      titleImg: 'https://www.checkpoint.com/es/wp-content/uploads/ayesa-logo-300x180.png',
      titleLink: 'https://www.ayesa.com/',
      texts: [
        'ayesaText1',
        'ayesaText2',
        'ayesaText3',
        'ayesaText4',
      ],
    },{
      color: 'orange',
      titleImg: 'https://www.autopistas.com/wp-content/uploads/2017/06/logo3.png',
      titleLink: 'https://www.autopistas.com/',
      texts: [
        'aumarText1',
        'aumarText2',
      ],
    }],
  }),
  methods: {  },
}
</script>


<style scoped>
  .experienceContainer {
    margin: 20px;
  }

  .formBloq {
    margin: 20px;    
  }
</style>